import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { Box, TextField, Typography } from '@material-ui/core'
import { JoditEditor } from 'components'
import usePermissions from 'hooks/usePermissions'
import constants from 'constants/index'
import useStyles from './styles'

const ActivityFormFields = ({
  control,
  errors,
  isCrossBoard = false,
  isShow = false,
}) => {
  const classes = useStyles()
  const permissions = usePermissions()
  const canManage =
    !isShow && permissions.permitted(constants.permissions.KANBAN_TASKS.MANAGE)

  return (
    <>
      <Box>
        <Typography className={classes.fieldLabel} color="textSecondary">
          Título *
        </Typography>
        <Controller
          as={
            <TextField
              variant="outlined"
              error={!!errors?.name}
              helperText={<>{errors?.name?.message}</>}
              fullWidth
              disabled={!canManage || isCrossBoard}
            />
          }
          control={control}
          name="name"
        />
      </Box>
      <Box>
        <Typography className={classes.fieldLabel} color="textSecondary">
          Por quê *
        </Typography>
        <Controller
          as={
            <TextField
              variant="outlined"
              multiline
              minRows={3}
              error={!!errors?.reason}
              helperText={<>{errors?.reason?.message}</>}
              fullWidth
              disabled={!canManage || isCrossBoard}
            />
          }
          control={control}
          name="reason"
        />
      </Box>
      <Box>
        <Typography className={classes.fieldLabel} color="textSecondary">
          Descrição *
        </Typography>
        <Controller
          as={
            <JoditEditor.Editor
              error={!!errors?.description}
              helperText={errors?.description?.message}
              disabled={!canManage || isCrossBoard}
            />
          }
          control={control}
          name="description"
        />
      </Box>
    </>
  )
}

ActivityFormFields.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  isCrossBoard: PropTypes.bool,
  isShow: PropTypes.bool,
}

export default ActivityFormFields
